import createEnvironment from './client'

export default createEnvironment
